import http from "../../http-common";

const get = (data) => http.post("/SystemParameter/FilterSystemParameter", data);

const update = (data) =>
  http.put("/SystemParameter/UpdateSystemParameter", data);

export default { get, update };
